import React, { useState, useEffect, useContext, useRef } from "react";
import Quilleditor from "../../Quilleditor/Quilleditor";
import "./Summary.scss";
import { ResumePopupContext } from "../../../Context/resumePopupContext";
import { useTranslation } from "react-i18next";
import InputEditable from "../../../Components/ContentEditable/InputEditable";
import Dragicon from "../../../Components/Dragicon/Dragicon";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import IconButton from "../../Buttons/IconButton/IconButton";
import { Overlay, Tooltip } from "react-bootstrap";
import { useOutsideClick } from "../../../Utils/UseOutsideClick";
import VisualSuggest from "../../../Components/SuggestionVisual/SuggestionVisual";

function Summary({
  resumeHandler,
  resumeUpdate,
  sectionId,
  resumeFields,
  showHideElements,
  setModalShow,
  styles,
  settings,
  resumeTitleHandler,
  handleEditorChange,
  resumeTitleRemove,
  contentAdder,
}) {
  const [t, i18n] = useTranslation("common");
  const { id } = useParams();
  const [showInfo, setShowInfo] = useState(false);
  const [showSuggest, setShowSuggest] = useState(false);
  const [profileJob, setProfileJob] = useState("");

  const target = useRef(null);

  const { showPopup, arrayIndex, setSuggestionIndex } =
    useContext(ResumePopupContext);

  const userInfo = useSelector((state) => state.particularuser.user);
  const profileData = useSelector((state) => state.editorData.profile);

  useEffect(() => {
    setProfileJob(
      profileData &&
        profileData.data &&
        profileData.data[0] &&
        profileData.data[0].jobTitle
    );
  }, [profileData]);

  const handleInfo = () => {
    setShowInfo(!showInfo);
  };

  const handleSuggestion = (job, index) => {
    setShowSuggest(true);
    setSuggestionIndex(index);
  };
  const hideSuggest = () => {
    setShowSuggest(false);
  };

  useOutsideClick(target, () => {
    if (showInfo && showInfo) {
      setShowInfo(!showInfo);
    }
  });

  return (
    <>
      <div className="card mb-4 section-card basic-scroll-summary">
        <div className="card-header d-flex justify-content-between align-items-center bg-white">
          <h4 className="card-title d-flex">
            <InputEditable
              sectionId={sectionId}
              resumeFields={resumeFields}
              onBlur={resumeTitleHandler}
              name="customTitle"
              onRemove={resumeTitleRemove}
            />
          </h4>
          {/* <div>
            <button className="btn extrafieldbtn">
              <span className="showlable">Show Section</span>
              <span className="switchbtn">
                <input
                  type="checkbox"
                  id="switch"
                  checked={resumeFields.show}
                  onChange={handleShowSection}
                />
                <label for="switch">Toggle</label>
              </span>
            </button>
            <DeleteButton
              className="btn extrafieldbtn ml-3"
              onClick={handleSectionDelete}
            />
            <button
              className="btn extrafieldbtn ml-3"
              onClick={addResumeField}
            >
              <img src="/images/plusgreen.svg" className="mr-2" alt="plus" />
              Add Additional Fields
            </button>
          </div> */}
        </div>
        {resumeFields && resumeFields.show && (
          <div className="card-body">
            {resumeFields &&
              resumeFields.data &&
              resumeFields.data.map((res, index) => {
                return (
                  <>
                    <i
                      className="fa fa-info-circle d-inline mr-2"
                      ref={target}
                      onClick={handleInfo}
                      aria-hidden="true"
                    ></i>
                    <Overlay
                      target={target.current}
                      show={showInfo}
                      placement="top"
                    >
                      {(props) => (
                        <Tooltip
                          id="overlay-example"
                          className="greenTooltip"
                          {...props}
                        >
                          <p>
                            A Resume Summary is professional statement written
                            in 3-5 sentences included at the top of your resume,
                            describing relevant experience, skills, and
                            achievements with the purpose of convincing a hiring
                            manager to read the rest of the resume
                          </p>
                          <a
                            href="https://www.qwikresume.com/resources/resume-summary-vs-objective-statement-what-to-include/"
                            target="_blank"
                          >
                            Read more about Resume summary vs Objective
                            Statement and What to Include?
                          </a>
                        </Tooltip>
                      )}
                    </Overlay>
                    <label className="d-inline">
                      Write 2-4 Clear sentences about your role, experience,
                      achievements & skills to interest the reader!{" "}
                    </label>

                    <div
                      style={{
                        backgroundColor: "#edf0f1",
                        padding: "2px",
                        borderRadius: "6px",
                        marginTop: "5px",
                      }}
                    >
                      <Quilleditor
                        type="basic"
                        theme={"snow"}
                        inivalue={
                          res?.description
                            ? res?.description?.replace(/\n|\r/g, "")
                            : ""
                        }
                        className={`${sectionId}focus${index}`}
                        current={index}
                        id={sectionId}
                        sectionId={sectionId}
                        placeholder="Whats the one thing that you want someone to remember to after reading your resume?"
                        setvalue={handleEditorChange}
                        onBlur={resumeUpdate}
                        handleSuggestion={handleSuggestion}
                      />
                      {showSuggest && showSuggest && (
                        <VisualSuggest
                          job={profileJob}
                          sectionId={sectionId}
                          index={index}
                          hideSuggest={hideSuggest}
                          showSuggest={showSuggest}
                          contentAdder={contentAdder}
                        />
                      )}
                    </div>
                    {/* <div className="mt-3" onClick={() => showSuggestion()}>
                      <IconButton
                        padding="4px 6px 5px 6px"
                        success
                        onClick={() => "#"}
                      >
                        <img
                          style={{ width: "16px", height: "16px" }}
                          src="/images/pluswhite.svg"
                        />
                      </IconButton>
                      <div className="mt-3">
                        <p className="pre-written">Add pre-written phrases</p>
                      </div>
                    </div> */}
                  </>
                );
              })}
          </div>
        )}
      </div>
    </>
  );
}

export default Summary;
